/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PushTokenUpsertForm { 
    /**
     * Identificativo del dispositivo. Non puo\' essere nullo o vuoto.
     */
    id_device: string;
    /**
     * Token Firebase Cloud Messaging. Non puo\' essere nullo o vuoto.
     */
    token: string;
}

